import { memo } from "react";
import { Container } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

export type TotalProps = {
  total: number;
};

const Total: React.FC<TotalProps> = ({ total }) => {
  const { locale = "it" } = useRouter();

  const t = {
    productsCounter: useTranslation("productListing.productsCounter", locale) || "",
    productsCounterOne: useTranslation("productListing.productsCounterOne", locale) || "",
  };
  const labelProductCounter = (total === 1) ? t.productsCounterOne : t.productsCounter

  return (
    <Container>{total} {labelProductCounter}</Container>
  )
};

export default memo(Total);
